import { useGetAssemblyTemplates } from '@/hooks/useGetAssemblyTemplates';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useMemo } from 'react';

export const useReportFilters = () => {
  const assemblyTemplate = useAtomValue(state.assemblyTemplate);
  useGetAssemblyTemplates();

  const filters = useMemo(() => {
    if (!assemblyTemplate) return [];
    return assemblyTemplate.fields.filter((field) => field.displayInReportFilters && field.key);
  }, [assemblyTemplate]);

  return {
    filters,
  };
};
